/* @sravni/react-design-system version 0.2.60 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import '../../Space/index.js';
import modules_6b210db9 from '../styles/Menu.module.less.js';
import Space from '../../Space/src/Space.js';

/**
 * @description The Menu component shows a list of actions that user can take
 *
 * @component
 * @example
 * ```jsx
 * <Menu>
 *   <Menu.Item>1 год</Menu.Item>
 *   <Menu.Item>2 года</Menu.Item>
 * </Menu>
 * ```
 */
var Menu = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, restProps = __rest(props, ["className", "children"]);
    var cx = useStyles(modules_6b210db9);
    var classNames = cx(className, 'container');
    return (React.createElement(Space, __assign({ ref: ref, "data-qa": "Menu", direction: "vertical", size: 0, className: classNames }, restProps), children));
});
Menu.defaultProps = {};
Menu.displayName = 'Menu';

export default Menu;
//# sourceMappingURL=Menu.js.map
